import React from 'react';
import { useTranslation } from 'react-i18next';

import { PageRootWrapper } from '@/components/shared/PageRootWrapper';
import { UserListContainer } from '@/components/pages/Users/Index/UserListForm';

export const UsersPage: React.FC = () => {
  const { t } = useTranslation();
  const title = t('pages.user.title');

  return (
    <PageRootWrapper
      title={title}
      breadcrumbItems={[{ label: t('pages.user.title') }]}
      containerType="userList"
      hasInnerWrapper={false}
    >
      <UserListContainer />
    </PageRootWrapper>
  );
};
